var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectionOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1695 0C13.237 0 12.3457 0.212114 11.5205 0.630491C10.9588 0.915233 10.4428 1.29355 10 1.74241C9.5572 1.29355 9.0412 0.915233 8.47946 0.630491C7.65423 0.212114 6.76297 0 5.83043 0C2.61555 0 0 2.59525 0 5.78523C0 8.04463 1.2026 10.4443 3.57435 12.9176C5.55464 14.9828 7.97913 16.7042 9.66429 17.7847L10 18L10.3357 17.7847C12.0209 16.7043 14.4454 14.9828 16.4256 12.9176C18.7974 10.4443 20 8.04463 20 5.78523C20 2.59525 17.3845 0 14.1695 0Z",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectionOut);
export default __webpack_public_path__ + "static/media/CollectionOut.d755b97c4900f32e72ecf6abe0ade7b9.svg";
export { ForwardRef as ReactComponent };